import type { Service } from "../types/content";

export const services: Service[] = [
  {
    title: "Plomberie générale",
    description:
      "Création et rénovation de réseaux, recherche de fuite, robinetterie, évacuations.",
    icon: "wrench",
  },
  {
    title: "Salle de bain clé en main",
    description:
      "Douche à l'italienne, PMR, meubles vasques : de la conception à la pose finale.",
    icon: "bath",
  },
  {
    title: "Chauffe-eau & ballon thermodynamique",
    description:
      "Remplacement, installation électrique ou thermodynamique, détartrage.",
    icon: "droplets",
  },
  {
    title: "Dépannage urgent",
    description:
      "Fuite, panne de chaudière, canalisation bouchée : intervention en moins de 2 h.",
    icon: "siren",
  },
  {
    title: "Contrat d'entretien",
    description:
      "Entretien annuel obligatoire de chaudière et PAC, attestation fournie.",
    icon: "shield",
  },
];

export const featuredService = {
  title: "Chauffage & pompe à chaleur",
  description:
    "Installation de chaudières à condensation, pompes à chaleur air/eau et planchers chauffants. Certifiés RGE, nous montons votre dossier d'aides.",
  tags: ["Chaudière gaz", "PAC air/eau", "Plancher chauffant", "Radiateurs"],
  image:
    "https://cdn.magicpatterns.com/patterns/generated-images/5a683859-4113-47f0-bf87-ce7fb49f2a43.jpg",
};
